import config from '../config';
import { fetchWithRetry } from '.';

export async function getStripeSession(sessionId) {
  console.log(`[getStripeSession] Called with sessionId: ${sessionId}`);

  if (!sessionId) {
    console.warn("[getStripeSession] No sessionId provided. Exiting.");
    return null;
  }

  const url = `${config.coreApi.protocol}://${config.coreApi.host}/stripe-webhook/session?session_id=${sessionId}`;
  
  console.log(`[getStripeSession] Fetching URL: ${url}`);

  try {
    const response = await fetchWithRetry(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log(`[getStripeSession] Received response with status: ${response.status}`);

    if (!response.ok) {
      console.error(`[getStripeSession] HTTP error! Status: ${response.status}`);
      try {
        const errorBody = await response.text();
        console.error(`[getStripeSession] Error response body: ${errorBody}`);
      } catch (e) {
        console.error("[getStripeSession] Could not parse error response body.");
      }
      return null;
    }

    const data = await response.json();
    console.log("[getStripeSession] Successfully fetched and parsed session data:", data);

    return data;
  } catch (error) {
    console.error("[getStripeSession] An unexpected error occurred during fetch:", error);
    return null;
  }
}